// TODO: resolve CHCP disables by bot
// eslint-disable-next-line max-classes-per-file
import { Action } from '@ngrx/store';
import { LoginRequest } from '../data/login.model';

export enum LoginActionTypes {
  LoginSubmit = '[Login] Submit',
  LoginSuccess = '[Login] Success',
  LoginError = '[Login] Error',
}

export class LoginSubmit implements Action {
  readonly type = LoginActionTypes.LoginSubmit;
  constructor(public payload: LoginRequest) {}
}

export class LoginSuccess implements Action {
  readonly type = LoginActionTypes.LoginSuccess;
  constructor(public payload: string) {}
}

export class LoginError implements Action {
  readonly type = LoginActionTypes.LoginError;
}

export type LoginAction = LoginSubmit | LoginSuccess | LoginError;
